var digistorm = {

    init: function () {
        this.videos.init();
    },

    videos: {

        init: function() {

            var _self = this;

            // check if there is a video player wrapper
            if ($('.video-player').length) {
                $('.video-player').each(function() {
                    _self.loadVideo(this)
                })
            }

            _self.controls()
            _self.carousel();
        },

        controls: function() {
            // initialise video controls
            $('.video-carousel .banner .control-pause').click(function () {
                $player = $(this).closest('.banner').find('.video-player');
                switch (digistorm.videos.togglePlay($player)) {
                    case 'no-data':
                        break;
                    case true:
                        $(this).removeClass('fa-play').addClass('fa-pause');
                        break;
                    case false:
                        $(this).removeClass('fa-pause').addClass('fa-play');
                        break;
                }
            });
    
            $('.video-carousel .banner .control-vol').click(function () {
                $player = $(this).closest('.banner').find('.video-player');
                switch (digistorm.videos.toggleMute($player)) {
                    case 'no-data':
                        break;
                    case true:
                        $(this).removeClass('fa-volume-off').addClass('fa-volume-up');
                        break;
                    case false:
                        $(this).removeClass('fa-volume-up').addClass('fa-volume-off');
                        break;
                }
            });
        },

        carousel: function() {
            // handle videos inside slick carousels
            $('.video-carousel').on('init', function(event, slick) {
                // mark carousel as initialized
                slick.is_initialized = true;
            }).on('setPosition', function(event, slick) {
                // synchronize slides with videos

                if (slick.is_initialized) {
                    // the slide up next
                    var $newSlide = $(slick.$slides[slick.currentSlide]);

                    // pause others
                    $newSlide.closest('.video-carousel').find('.banner').not($newSlide).find('.video-player').each(function(i, e) {
                        if (digistorm.iOS) {
                            // currently there's a bug with plyr where pause won't work on iOS
                            digistorm.videos.stopVideo($(e));
                        } else {
                            digistorm.videos.pauseVideo($(e));
                        }
                    });

                    // play new slide
                    var video = $newSlide.find('.video-player');
                    digistorm.videos.playVideo(video);
                    if (video.data() && video.data().player) {
                        // This slide is a video, pause slick autoslide
                        slick.$slider.slick('slickPause');
                    } else {
                        // This slide is not a video, resume slick autoslide
                        slick.$slider.slick('slickPlay');
                        $(".circleProgress").css('animation-duration', 5.9 + 's');
                    }
                }
            });
        },

        loadVideo: function(el) {
            // load a video element

            // get each config attr from this element
            var settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            var player = $(el).find('.player')

            var plyr = new Plyr(player[0], settings)
            // set up each video
            $(el).data({
                player: plyr
            });

            // if a carousel video, go to the next slide on video end
            var $carousel = $(el).closest('.video-carousel');
            if ($carousel.length) {
                
                if (plyr.source && plyr.source.indexOf('youtube') >= 0) {
                    // youtube loop doesn't work, manually detect end of video
                    plyr.on('timeupdate', function(event) {
                        if (plyr.currentTime >= plyr.duration - 0.1) {
                            plyr.restart();
                            if ($carousel.find('.banner').length > 1) {
                                $carousel.slick('slickNext');
                            }
                        }
                    });
                } else {
                    // on loop, go to the next slide
                    plyr.on('seeked', function (event) {
                        $carousel.slick('slickNext');
                    });
                }

                plyr.on('playing', function() {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause');
                });
                plyr.on('pause', function() {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play').addClass('fa-pause');
                });
            }

            if (settings.muted && settings.autoplay) {
                digistorm.videos.attemptPlay(plyr);
            }
        },

        attemptPlay: function(player, count) {
            // attempts to play the video multiple times in case element is still loading

            if (!Number.isInteger(count)) {
                count = 0;
            }
        
            player.volume = 0;
            player.muted = true;
            player.play();
            if (count < 15) {
                setTimeout(function() {
                    if (!player.playing) {
                        count++;
                        digistorm.videos.attemptPlay(player, count);
                    }
                }, 1000);
            }
        },

        playVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.play()
            }

        },
        pauseVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.pause()
            }
        },
        stopVideo: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.stop()
            }
        },
        togglePlay: function($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.togglePlay()
                return $el.data().player.playing;
            }
            return 'no-data';
        },
        toggleMute: function($el) {
            if ($el.data() && $el.data().player) {
                player = $el.data().player;
                if (player.volume == 0) {
                    player.volume = 1;
                    return true;
                } else {
                    player.volume = 0;
                    return false;
                }
            }
            return 'no-data';
        }
    }
}

// Yo!
$(document).ready(function () {
    digistorm.init();
});